module.exports = __webpack_public_path__ + "IGDC19-573d9228.webp";